var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7","cy":"7","r":"7","fill":"#6EAC51","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.82777 4.30859L10.7689 5.1363L5.90015 10.7701L3.23047 7.68095L4.17163 6.85325L5.90015 8.85338L9.82777 4.30859Z","fill":"white","key":1})]);
}

CheckCircle.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
